export default __webpack_public_path__ + "050a44624c0db7589ba962f7b0155554.svg";